import { render, staticRenderFns } from "./enterpriseBranchDetail.vue?vue&type=template&id=e9d1bbba&scoped=true"
import script from "./enterpriseBranchDetail.vue?vue&type=script&lang=js"
export * from "./enterpriseBranchDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/articleDetail.css?vue&type=style&index=0&id=e9d1bbba&prod&scoped=true&lang=css&external"
import style1 from "./enterpriseBranchDetail.vue?vue&type=style&index=1&id=e9d1bbba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d1bbba",
  null
  
)

export default component.exports